import { IssueTypeIdentifierValueService as OvermapIssueTypeIdentifierValueService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeIdentifierValueService extends OvermapIssueTypeIdentifierValueService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
